module.exports = __webpack_public_path__ + "static/chom-7579e1a9e7cda6ded05c4a6cf2fcdca4.png";